import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const WorkGroupManagementLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.work_groups_management',
    link: '/groups/list/workgroups',
    icon: 'navigation-link__list-item',
});